import React, { useMemo } from 'react'
import Default from './Default'
import LifetimeReplacement from './LifetimeReplacement'
import { returnType } from './type'

const OrderDetailItemButton = ({ data }) => {
  const { type } = { ...data }

  const Component = useMemo(() => {
    if (type === returnType.lifetime) return LifetimeReplacement

    return Default
  }, [type])

  return (
    <Component data={data} />
  )
}

export default OrderDetailItemButton
